import React, { useEffect, useRef } from 'react'

interface PinInputProps {
  value: string
  onChange: (value: string) => void
  maxLength?: number
  error?: boolean
}

export const PinInput: React.FC<PinInputProps> = ({ value, maxLength = 8, error = false }) => {
  const dots = Array.from({ length: maxLength }, (_, i) => i < value.length)
  const shakeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (error && shakeRef.current) {
      shakeRef.current.classList.add('animate-shake')
      const t = setTimeout(() => shakeRef.current?.classList.remove('animate-shake'), 500)
      return () => clearTimeout(t)
    }
  }, [error])

  return (
    <div className="flex flex-col items-center gap-3 w-full mb-4">
      <p className="text-xs font-medium uppercase tracking-widest" style={{ color: 'var(--text-tertiary)' }}>
        Pincode
      </p>
      <div
        ref={shakeRef}
        className="flex gap-3 items-center justify-center"
        style={{
          animation: undefined,
        }}
      >
        {dots.map((filled, i) => (
          <div
            key={i}
            className="transition-all duration-150"
            style={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: filled
                ? error ? '#ef4444' : 'var(--kvh-red)'
                : 'var(--border)',
              border: `2px solid ${filled ? (error ? '#ef4444' : 'var(--kvh-red)') : 'var(--border)'}`,
              transform: filled ? 'scale(1.1)' : 'scale(1)',
            }}
          />
        ))}
      </div>
      {error && (
        <p className="text-red-500 text-xs font-medium">Ongeldige pincode</p>
      )}
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-6px); }
          40% { transform: translateX(6px); }
          60% { transform: translateX(-4px); }
          80% { transform: translateX(4px); }
        }
        .animate-shake { animation: shake 0.4s ease-in-out; }
      `}</style>
    </div>
  )
}
